export const getFullName = name =>
  name.first_name || name.last_name
    ? `${name.first_name || ''} ${name.last_name || ''}`.trim()
    : '(name missing)';
